import { useEffect, useState } from "react";
import axios from "axios";
import './Login.scss';
import SignupStepper from './SignupStepper';
import { useLocation, useNavigate } from 'react-router-dom';
import MainURL from "../../MainURL";
import { clearSignupUserType, getSignupUserType } from "./userTypeUtils";
import { FaCheck } from "react-icons/fa";
import { CiWarning } from "react-icons/ci";
import LogisterAgree, { AgreementData } from "./LogisterAgree";
import { SIGNUP_SOURCE_ETC, SIGNUP_SOURCE_OPTIONS, buildSignupSource } from "./signupSource";

export default function LogisterDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const propsData = location.state?.sort === 'sns' ? location.state.data : '';

  const [currentTab, setCurrentTab] = useState(1);
  const [agreementData, setAgreementData] = useState<AgreementData | null>(null);

  const [logisterAccount, setLogisterAccount] = useState(
    location.state?.sort === 'sns' ? propsData.email : ''
  );
  const [logisterAccountCheck, setLogisterAccountCheck] = useState(false);
  const [logisterAccountAuthNum, setLogisterAccountAuthNum] = useState('');
  const [logisterAccountAuthInput, setLogisterAccountAuthInput] = useState('');
  const [logisterAccountAuthCheck, setLogisterAccountAuthCheck] = useState(false);
  const [logisterPasswd, setLogisterPasswd] = useState('');
  const [logisterPasswdCheck, setLogisterPasswdCheck] = useState('');
  const [logisterNickName, setLogisterNickName] = useState('');
  const [logisterChurch, setLogisterChurch] = useState('');
  const [logisterDetail, setLogisterDetail] = useState('');
  const [signupSource, setSignupSource] = useState('');
  const [signupSourceEtc, setSignupSourceEtc] = useState('');
  const signupUserType = getSignupUserType();

  useEffect(() => {
    if (!signupUserType && currentTab !== 3) {
      navigate('/login/usertype', {
        replace: true,
        state: {
          signupFlow: true,
          sort: location.state?.sort || 'email',
          data: location.state?.data,
        },
      });
    }
  }, [signupUserType, navigate, location.state, currentTab]);

  const isFormValid = logisterAccount !== '' && logisterNickName !== '' && logisterChurch !== '' && signupSource !== '' && !!signupUserType;

  const handleLogister = async () => {
    const userData = {
      checkUsingPolicy: agreementData?.checkUsingPolicy ?? false,
      checkPersonalInfo: agreementData?.checkPersonalInfo ?? false,
      checkContentsRestrict: agreementData?.checkContentsRestrict ?? false,
      checkInfoToOthers: agreementData?.checkInfoToOthers ?? false,
      checkServiceNotifi: agreementData?.checkServiceNotifi ?? false,
      email: logisterAccount,
      password: logisterPasswd,
      userNickname: logisterNickName,
      userChurch: logisterChurch,
      userType: signupUserType,
      userDetail: logisterDetail,
      signupSource: buildSignupSource(signupSource, signupSourceEtc),
      userURL: location.state.sort === 'sns' ? propsData.userURL : 'email',
    };

    if (location.state.sort !== 'sns' && !logisterAccountCheck) {
      alert('이메일 중복확인을 해주세요');
      return;
    }
    if (location.state.sort !== 'sns' && !logisterAccountAuthCheck) {
      alert('이메일 인증을 완료해주세요');
      return;
    }
    if (!signupUserType) {
      alert('회원 유형을 먼저 선택해주세요.');
      navigate('/login/usertype', {
        state: {
          signupFlow: true,
          sort: location.state?.sort || 'email',
          data: location.state?.data,
        },
      });
      return;
    }

    try {
      const res = await axios.post(`${MainURL}/login/logisterdo`, { userData });
      if (res.data) {
        clearSignupUserType();
        setCurrentTab(3);
      }
    } catch {
      alert('다시 시도해주세요.');
    }
  };

  const handleCheckAccount = async () => {
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(logisterAccount);
    if (!isEmail) {
      alert('이메일 형식이 아닙니다.');
      return;
    }
    try {
      const res = await axios.get(`${MainURL}/login/logincheckaccount/${logisterAccount}`);
      if (res.data) {
        alert('중복된 이메일 계정이 있습니다.');
        setLogisterAccountCheck(false);
      } else {
        alert('사용할 수 있는 이메일 계정입니다. 해당 메일로 인증번호를 보냈습니다.');
        setLogisterAccountCheck(true);
        handleCheckAccountAuth();
      }
    } catch {
      alert('다시 시도해주세요.');
    }
  };

  const handleCheckAccountAuth = async () => {
    try {
      const res = await axios.post(`${MainURL}/login/loginaccountauth`, { email: logisterAccount });
      if (res.data) {
        setLogisterAccountAuthNum(JSON.stringify(res.data.num));
      }
    } catch {
      alert('다시 시도해주세요.');
    }
  };

  return (
    <div className="lp">
      <main className="lp__page-wrap">

            <SignupStepper activeStep={currentTab + 2} />

            {currentTab === 1 && (
              <LogisterAgree
                onNext={(data) => {
                  setAgreementData(data);
                  setCurrentTab(2);
                }}
              />
            )}

            {currentTab === 2 && (
              <div className="lp__auth-card">
                <div className="lp__auth-title-row">
                  <div>
                    <h2 className="lp__auth-title">회원가입</h2>
                    <p className="lp__auth-subtitle">다음 정보를 입력해주세요.</p>
                  </div>
                </div>

                <form
                  className="lp__form-grid"
                  onSubmit={(e) => { e.preventDefault(); handleLogister(); }}
                >
                  <label className="lp__field">
                    <span className="lp__field-label">
                      <span className="lp__required">이메일 주소</span>
                      {location.state?.sort === 'email' && logisterAccount !== '' && (
                        logisterAccountCheck
                          ? <FaCheck color="var(--lp-success)" size={13} />
                          : <CiWarning color="var(--lp-danger)" size={15} />
                      )}
                    </span>
                    <div className="lp__input-inline">
                      <input
                        className="lp__input"
                        type="text"
                        placeholder="example@church.or.kr"
                        value={logisterAccount}
                        maxLength={45}
                        readOnly={location.state?.sort === 'sns'}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length === 0) {
                            setLogisterAccount('');
                            setLogisterAccountCheck(false);
                            return;
                          }
                          if (/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value)) {
                            alert('한글은 입력할 수 없습니다.');
                            return;
                          }
                          setLogisterAccount(value);
                        }}
                      />
                      {location.state?.sort === 'email' && (
                        <button className="lp__inline-btn" type="button" onClick={handleCheckAccount}>
                          중복확인
                        </button>
                      )}
                    </div>
                  </label>

                  {logisterAccountCheck && (
                    <label className="lp__field">
                      <span className="lp__field-label">
                        <span className="lp__required">이메일 인증</span>
                        {logisterAccountAuthCheck
                          ? <FaCheck color="var(--lp-success)" size={13} />
                          : <CiWarning color="var(--lp-danger)" size={15} />
                        }
                      </span>
                      <div className="lp__input-inline">
                        <input
                          className="lp__input"
                          type="text"
                          placeholder="인증번호를 입력하세요"
                          value={logisterAccountAuthInput}
                          maxLength={10}
                          onChange={(e) => {
                            if (/^[0-9]*$/.test(e.target.value)) {
                              setLogisterAccountAuthInput(e.target.value);
                            }
                          }}
                        />
                        <button
                          className="lp__inline-btn"
                          type="button"
                          onClick={() => {
                            if (logisterAccountAuthNum === logisterAccountAuthInput) {
                              alert('인증되었습니다.');
                              setLogisterAccountAuthCheck(true);
                            } else {
                              alert('인증 번호가 일치하지 않습니다.');
                            }
                          }}
                        >
                          인증하기
                        </button>
                      </div>
                    </label>
                  )}

                  {location.state?.sort !== 'sns' && (
                    <>
                      <div className="lp__form-grid lp__form-grid--two">
                        <label className="lp__field">
                          <span className="lp__field-label">
                            <span className="lp__required">비밀번호</span>
                          </span>
                          <input
                            className="lp__input"
                            type="password"
                            placeholder="비밀번호를 입력하세요"
                            value={logisterPasswd}
                            maxLength={100}
                            onChange={(e) => setLogisterPasswd(e.target.value)}
                          />
                        </label>
                        <label className="lp__field">
                          <span className="lp__field-label">
                            <span className="lp__required">비밀번호 확인</span>
                            {logisterPasswd && logisterPasswdCheck && (
                              logisterPasswd === logisterPasswdCheck
                                ? <FaCheck color="var(--lp-success)" size={13} />
                                : <CiWarning color="var(--lp-danger)" size={15} />
                            )}
                          </span>
                          <input
                            className="lp__input"
                            type="password"
                            placeholder="동일한 비밀번호를 입력하세요"
                            value={logisterPasswdCheck}
                            onChange={(e) => setLogisterPasswdCheck(e.target.value)}
                          />
                        </label>
                      </div>
                      <div className="lp__password-hint">
                        <span className="lp__chip">영문 포함</span>
                        <span className="lp__chip">숫자 포함</span>
                        <span className="lp__chip">8자 이상</span>
                      </div>
                    </>
                  )}

                  <div className="lp__form-grid lp__form-grid--two">
                    <label className="lp__field">
                      <span className="lp__field-label"><span className="lp__required">닉네임</span></span>
                      <input
                        className="lp__input"
                        type="text"
                        placeholder="활동에 사용할 이름"
                        value={logisterNickName}
                        onChange={(e) => setLogisterNickName(e.target.value)}
                      />
                    </label>
                    <label className="lp__field">
                      <span className="lp__field-label"><span className="lp__required">교회명</span></span>
                      <input
                        className="lp__input"
                        type="text"
                        placeholder="소속 교회명을 입력하세요"
                        value={logisterChurch}
                        onChange={(e) => setLogisterChurch(e.target.value)}
                      />
                    </label>
                  </div>

                  <div className="lp__field">
                    <span className="lp__field-label">
                      <span className="lp__required">사역자모아를 어떻게 알게 되셨나요?</span>
                    </span>
                    <div className="lp__source-grid">
                      {[...SIGNUP_SOURCE_OPTIONS, SIGNUP_SOURCE_ETC].map((option) => (
                        <button
                          key={option}
                          type="button"
                          className={`lp__source-chip${signupSource === option ? ' is-on' : ''}`}
                          aria-pressed={signupSource === option}
                          onClick={() => setSignupSource(option)}
                        >
                          {option}
                        </button>
                      ))}
                    </div>
                    {signupSource === SIGNUP_SOURCE_ETC && (
                      <input
                        className="lp__input"
                        type="text"
                        placeholder="어디서 알게 되셨는지 적어주세요"
                        value={signupSourceEtc}
                        maxLength={80}
                        onChange={(e) => setSignupSourceEtc(e.target.value)}
                      />
                    )}
                  </div>

                  <label className="lp__field">
                    <span className="lp__field-label">
                      이용하고자 하시는 서비스
                      <small>선택 입력</small>
                    </span>
                    <input
                      className="lp__input"
                      type="text"
                      placeholder="ex. 구인구직, 수련회 장소, 예배사역"
                      value={logisterDetail}
                      onChange={(e) => setLogisterDetail(e.target.value)}
                    />
                  </label>

                  <p className="lp__helper">가입 완료 후 프로필 설정에서 추가 정보를 수정하실 수 있습니다.</p>
                </form>
              </div>
            )}

            {currentTab === 2 && (
              <div className="lp__action-row">
                <button
                  className="lp__btn lp__btn--soft"
                  type="button"
                  onClick={() => setCurrentTab(1)}
                >
                  이전 단계로
                </button>
                <button
                  className="lp__btn lp__btn--primary"
                  type="button"
                  disabled={!isFormValid}
                  onClick={handleLogister}
                >
                  회원가입
                </button>
              </div>
            )}

            {currentTab === 3 && (
              <div className="lp__auth-card" style={{ textAlign: 'center' }}>
                <div className="lp__step-bullet" style={{ margin: '0 auto 20px', width: 64, height: 64, background: 'var(--brand-900)', borderColor: 'var(--brand-900)', color: 'white' }}>
                  <FaCheck size={26} />
                </div>
                <h2 className="lp__auth-title">가입이 완료되었습니다</h2>
                <p className="lp__helper">이제 로그인하고 서비스를 이용해보세요.</p>
                <div className="lp__action-row">
                  <button
                    className="lp__btn lp__btn--primary"
                    type="button"
                    onClick={() => navigate('/login')}
                  >
                    로그인하러 가기
                  </button>
                </div>
              </div>
            )}

      </main>
    </div>
  );
}
